import {compose, pathOr, map, uniq} from 'ramda'

const selectProductTypes = compose(
  uniq,
  map(({productType}) => productType),
  pathOr([], ['company', 'financingOptions'])
)

export default selectProductTypes
